import React from "react";
import PropTypes from "prop-types";
import { constants } from "@qgiv/core-js";
import { FormikField } from "@qgiv/core-donor";
import {
    validateEmergencyContactFirstName,
    validateEmergencyContactLastName,
    validateRequiredEmergencyContactEmail,
    validateOptionalEmergencyContactEmail,
    validateEmergencyContactPhone,
    validateRequiredEmergencyContactCell,
    validateOptionalEmergencyContactCell,
} from "./formik/validation";

const EmergencyContactFields = ({
    emergencyContactCell = 0,
    emergencyContactEmail = 0,
    cellPhoneNumberLabel = "Cell",
    emailLabel = "Email",
    firstNameLabel = "First Name",
    lastNameLabel = "Last Name",
    phoneNumberLabel = "Phone",
    suffix = "",
    Country = "US",
}) => {
    const suffixId = suffix ? `-${suffix}` : "";
    const suffixName = suffix ? `_${suffix}` : "";

    const { ENUMS } = constants;

    const {
        Status: { INACTIVE, REQUIRED },
    } = ENUMS;

    const requiredCell = emergencyContactCell === REQUIRED;
    const requiredEmail = emergencyContactEmail === REQUIRED;

    const hasEmergencyEmail = emergencyContactEmail !== INACTIVE;
    const hasEmergencyCell = emergencyContactCell !== INACTIVE;

    return (
        <>
            <div className="col col--12 col--sm-6">
                <FormikField
                    id={`Emergency-Contact-First-Name${suffixId}`}
                    name={`Emergency_Contact_First_Name${suffixName}`}
                    label={firstNameLabel}
                    type="text"
                    validate={validateEmergencyContactFirstName}
                    ariaRequired="true"
                />
            </div>
            <div className="col col--12 col--sm-6">
                <FormikField
                    id={`Emergency-Contact-Last-Name${suffixId}`}
                    name={`Emergency_Contact_Last_Name${suffixName}`}
                    label={lastNameLabel}
                    type="text"
                    validate={validateEmergencyContactLastName}
                    ariaRequired="true"
                />
            </div>
            {hasEmergencyEmail && (
                <div className="col col--12">
                    <FormikField
                        id={`Emergency-Contact-Email${suffixId}`}
                        name={`Emergency_Contact_Email${suffixName}`}
                        label={emailLabel}
                        type="text"
                        validate={
                            requiredEmail
                                ? validateRequiredEmergencyContactEmail
                                : validateOptionalEmergencyContactEmail
                        }
                        descText={!requiredEmail ? "Optional" : ""}
                        ariaRequired={!requiredEmail ? "false" : "true"}
                    />
                </div>
            )}
            <div className="col col--12 col--sm-6">
                <FormikField
                    id={`Emergency-Contact-Phone${suffixId}`}
                    name={`Emergency_Contact_Phone${suffixName}`}
                    label={phoneNumberLabel}
                    type="tel"
                    validate={validateEmergencyContactPhone}
                    ariaRequired="true"
                    country={Country}
                />
            </div>
            {hasEmergencyCell && (
                <div className="col col--12 col--sm-6">
                    <FormikField
                        id={`Emergency-Contact-Cell${suffixId}`}
                        name={`Emergency_Contact_Cell${suffixName}`}
                        label={cellPhoneNumberLabel}
                        type="tel"
                        autoComplete="tel"
                        validate={
                            requiredCell
                                ? validateRequiredEmergencyContactCell
                                : validateOptionalEmergencyContactCell
                        }
                        descText={!requiredCell ? "Optional" : ""}
                        ariaRequired={!requiredEmail ? "false" : "true"}
                        country={Country}
                    />
                </div>
            )}
        </>
    );
};

EmergencyContactFields.propTypes = {
    emergencyContactCell: PropTypes.number,
    emergencyContactEmail: PropTypes.number,
    cellPhoneNumberLabel: PropTypes.string.isRequired,
    emailLabel: PropTypes.string.isRequired,
    firstNameLabel: PropTypes.string.isRequired,
    lastNameLabel: PropTypes.string.isRequired,
    phoneNumberLabel: PropTypes.string.isRequired,
    suffix: PropTypes.string,
    Country: PropTypes.string,
};

export default EmergencyContactFields;
